/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseServiceUrl } from '../base-service-url';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { createKpiFarmSetting } from '../fn/kpi-farm-settings/create-kpi-farm-setting';
import { CreateKpiFarmSetting$Params } from '../fn/kpi-farm-settings/create-kpi-farm-setting';
import { deleteKpiFarmSetting } from '../fn/kpi-farm-settings/delete-kpi-farm-setting';
import { DeleteKpiFarmSetting$Params } from '../fn/kpi-farm-settings/delete-kpi-farm-setting';
import { getAllKpiFarmSetting } from '../fn/kpi-farm-settings/get-all-kpi-farm-setting';
import { GetAllKpiFarmSetting$Params } from '../fn/kpi-farm-settings/get-all-kpi-farm-setting';
import { getHarvestPredictionWeightValues } from '../fn/kpi-farm-settings/get-harvest-prediction-weight-values';
import { GetHarvestPredictionWeightValues$Params } from '../fn/kpi-farm-settings/get-harvest-prediction-weight-values';
import { getKpiFarmSettingById } from '../fn/kpi-farm-settings/get-kpi-farm-setting-by-id';
import { GetKpiFarmSettingById$Params } from '../fn/kpi-farm-settings/get-kpi-farm-setting-by-id';
import { HarvestPredictionValuesDto } from '../models/harvest-prediction-values-dto';
import { KpiFarmSetting } from '../models/kpi-farm-setting';
import { updateKpiFarmSetting } from '../fn/kpi-farm-settings/update-kpi-farm-setting';
import { UpdateKpiFarmSetting$Params } from '../fn/kpi-farm-settings/update-kpi-farm-setting';

@Injectable({ providedIn: 'root' })
export class KpiFarmSettingsService extends BaseServiceUrl {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getHarvestPredictionWeightValues()` */
  static readonly GetHarvestPredictionWeightValuesPath = '/api/harvestPrediction/weight';

  /**
   * Get Harvest Prediction Weight Values.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getHarvestPredictionWeightValues()` instead.
   *
   * This method doesn't expect any request body.
   */
  getHarvestPredictionWeightValues$Response(params?: GetHarvestPredictionWeightValues$Params, context?: HttpContext): Observable<StrictHttpResponse<HarvestPredictionValuesDto>> {
    return getHarvestPredictionWeightValues(this.http, this.rootUrl, params, context);
  }

  /**
   * Get Harvest Prediction Weight Values.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getHarvestPredictionWeightValues$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getHarvestPredictionWeightValues(params?: GetHarvestPredictionWeightValues$Params, context?: HttpContext): Observable<HarvestPredictionValuesDto> {
    return this.getHarvestPredictionWeightValues$Response(params, context).pipe(
      map((r: StrictHttpResponse<HarvestPredictionValuesDto>): HarvestPredictionValuesDto => r.body)
    );
  }

  /** Path part for operation `getAllKpiFarmSetting()` */
  static readonly GetAllKpiFarmSettingPath = '/api/kpisettings';

  /**
   * Get All Kpi Farm Setting.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getAllKpiFarmSetting()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAllKpiFarmSetting$Response(params?: GetAllKpiFarmSetting$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<KpiFarmSetting>>> {
    return getAllKpiFarmSetting(this.http, this.rootUrl, params, context);
  }

  /**
   * Get All Kpi Farm Setting.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getAllKpiFarmSetting$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAllKpiFarmSetting(params?: GetAllKpiFarmSetting$Params, context?: HttpContext): Observable<Array<KpiFarmSetting>> {
    return this.getAllKpiFarmSetting$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<KpiFarmSetting>>): Array<KpiFarmSetting> => r.body)
    );
  }

  /** Path part for operation `createKpiFarmSetting()` */
  static readonly CreateKpiFarmSettingPath = '/api/kpisettings';

  /**
   * Create Kpi Farm Setting.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createKpiFarmSetting()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createKpiFarmSetting$Response(params: CreateKpiFarmSetting$Params, context?: HttpContext): Observable<StrictHttpResponse<KpiFarmSetting>> {
    return createKpiFarmSetting(this.http, this.rootUrl, params, context);
  }

  /**
   * Create Kpi Farm Setting.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createKpiFarmSetting$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createKpiFarmSetting(params: CreateKpiFarmSetting$Params, context?: HttpContext): Observable<KpiFarmSetting> {
    return this.createKpiFarmSetting$Response(params, context).pipe(
      map((r: StrictHttpResponse<KpiFarmSetting>): KpiFarmSetting => r.body)
    );
  }

  /** Path part for operation `getKpiFarmSettingById()` */
  static readonly GetKpiFarmSettingByIdPath = '/api/kpisettings/{kpiFarmSettingId}';

  /**
   * Get Kpi Farm Setting By Id.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getKpiFarmSettingById()` instead.
   *
   * This method doesn't expect any request body.
   */
  getKpiFarmSettingById$Response(params: GetKpiFarmSettingById$Params, context?: HttpContext): Observable<StrictHttpResponse<KpiFarmSetting>> {
    return getKpiFarmSettingById(this.http, this.rootUrl, params, context);
  }

  /**
   * Get Kpi Farm Setting By Id.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getKpiFarmSettingById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getKpiFarmSettingById(params: GetKpiFarmSettingById$Params, context?: HttpContext): Observable<KpiFarmSetting> {
    return this.getKpiFarmSettingById$Response(params, context).pipe(
      map((r: StrictHttpResponse<KpiFarmSetting>): KpiFarmSetting => r.body)
    );
  }

  /** Path part for operation `updateKpiFarmSetting()` */
  static readonly UpdateKpiFarmSettingPath = '/api/kpisettings/{kpiFarmSettingId}';

  /**
   * Update Kpi Farm Setting.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateKpiFarmSetting()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateKpiFarmSetting$Response(params: UpdateKpiFarmSetting$Params, context?: HttpContext): Observable<StrictHttpResponse<KpiFarmSetting>> {
    return updateKpiFarmSetting(this.http, this.rootUrl, params, context);
  }

  /**
   * Update Kpi Farm Setting.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateKpiFarmSetting$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateKpiFarmSetting(params: UpdateKpiFarmSetting$Params, context?: HttpContext): Observable<KpiFarmSetting> {
    return this.updateKpiFarmSetting$Response(params, context).pipe(
      map((r: StrictHttpResponse<KpiFarmSetting>): KpiFarmSetting => r.body)
    );
  }

  /** Path part for operation `deleteKpiFarmSetting()` */
  static readonly DeleteKpiFarmSettingPath = '/api/kpisettings/{kpiFarmSettingId}';

  /**
   * Delete Kpi Farm Setting.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteKpiFarmSetting()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteKpiFarmSetting$Response(params: DeleteKpiFarmSetting$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return deleteKpiFarmSetting(this.http, this.rootUrl, params, context);
  }

  /**
   * Delete Kpi Farm Setting.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteKpiFarmSetting$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteKpiFarmSetting(params: DeleteKpiFarmSetting$Params, context?: HttpContext): Observable<void> {
    return this.deleteKpiFarmSetting$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
